import ModuleData from '../../types/ModuleData'
import { ruleMatchesProperties } from './ConstelaConfiguration'

export const getCurrentModuleVariation = <T extends ModuleData>(
  module: T | undefined,
  globalProperties: Record<string, string>,
  moduleProperties?: Record<string, string>
): T | undefined => {
  if (!module) {
    return undefined
  }
  let result: T = module
  const properties = { ...globalProperties, ...(moduleProperties ?? {}), module: module.id }
  for (const variation of module.variations ?? []) {
    if (ruleMatchesProperties(variation, properties)) {
      result = {
        ...result,
        ...variation.override
      }
    }
  }
  return result
}
